import React, {useEffect, useState} from "react";
import {collection, query, getDocs, limit, orderBy, where} from "@firebase/firestore";
import {Business, CurrentUser, UserType} from "../../types/Types";
import AuthCheck from "../../components/auth/AuthCheck";
import "./../../App.css"
import {db} from "../../firebase/FirebaseProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";

interface Props {
  currentUser: CurrentUser,
  businessMap: Map<string, Business>,
}

function EventsPage(props: Props) {
  const [events, setEvents] = useState<Array<Event>>([]);

  useEffect(() => {(async () => {
    let events = new Array<Event>();
    const eventsCollections = query(
        collection(db, 'events'),
        where("active", "==",true),
        orderBy("createdAt", "desc"),
        limit(200),
    );
    const eventsSnapshot = await getDocs(eventsCollections);
    eventsSnapshot.forEach((doc) => {
      events.push(doc.data() as Event);
    });
    setEvents(events);
  })();
  }, []);

  return (
      <>
        <AuthCheck />
        <div>

          {props.currentUser.userType == UserType.LOCATION_MANAGER && <div>
              <div className={"primary-button pe-2 mb-3"}>
                  Create Event
                  <div className={"d-inline-block ms-2"}>
                      <FontAwesomeIcon icon={faPlus}/>
                  </div>
              </div>
          </div>}

          <div className={"list-bg"}>
            {props.currentUser.userType == UserType.CUSTOMER && <div className={"list-title"}>
              <div className={"d-inline-block"}><b>All Events</b></div>
            </div>}
            {/*{offers.map((location, index) => (*/}
            {/*    <div className={` ${index == locations.length-1 ? 'mb-0' : 'mb-2'}`}>*/}
            {/*      <LocationRow location={location} business={props.businessMap.get(location.business)} />*/}
            {/*    </div>*/}
            {/*))}*/}
            {(!events || events.length == 0) && <div className={"basic-box mb-0 left-align"}>No events have been added yet.</div>}
          </div>
        </div>
      </>
  );
}

export default EventsPage;
